<template>
  <div class="layout-main">
    <Header :PATH="path" />
    <div v-if="navArr.length > 1" class="nav-box">
      <div class="nav-item" v-for="(item, index) in navArr" :key="index">
        <div v-if="index !== 0" class="nav-icon"><a-icon type="right" /></div>
        <div class="nav-name" @click="toPath(item.path, item.redirect)">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="app-main-container">
      <a-config-provider :locale="zhCN">
        <TransitionGroup
          name="animate"
          @before-enter="beforeEnter"
          @enter="enter"
        >
          <router-view key="1" />
        </TransitionGroup>
      </a-config-provider>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./header.vue";
import Footer from "./footer.vue";
import gsap from "gsap";
import zhCN from "ant-design-vue/lib/locale/zh_CN";

export default {
  components: { Header, Footer },
  watch: {
    $route: {
      handler(to) {
        this.path = to.path;
        this.navArr = this.getMatchedRouteHierarchy(
          to.path,
          this.$router.options.routes
        );
      },
      immediate: true,
    },
    USER: {
      handler(newVal) {
        if (newVal && newVal.YHLX) {
          this.$store.dispatch("set_menus", { ZT: 1, YHLX: newVal.YHLX });
        } else if (newVal && !newVal.YHLX) {
          this.$login({ TYPE: "ROLE" })
            .then(() => {
              this.$store.dispatch("set_userinfo");
            })
            .catch((reason) => {
              if (reason !== "cancel") console.log("角色切换取消");
            });
        } else {
          this.$store.dispatch("set_menus", { ZT: 1 });
        }
      },
    },
  },
  data() {
    return {
      zhCN,
      path: "/",
      navArr: [],
    };
  },
  computed: {
    USER() {
      return this.$store.state.USERINFO;
    },
  },
  mounted() {
    this.$store
      .dispatch("set_userinfo")
      .catch(() => this.$store.dispatch("set_menus", { ZT: 1 }));
  },
  methods: {
    toPath(path, redirect) {
      if (path === this.path || redirect === this.path) return;
      this.$router.push(path);
    },
    getMatchedRouteHierarchy(path, routes) {
      const pathSegments = path.split("/").filter(Boolean);
      const pathHierarchy = pathSegments.reduce((acc, _, index) => {
        const currentPath = "/" + pathSegments.slice(0, index + 1).join("/");
        acc.push(currentPath);
        return acc;
      }, []);
      if (pathHierarchy.length <= 1) return [];
      if (path.includes("/search")) return [];
      return pathHierarchy.map((path) => {
        const findRoute = (routes, path) => {
          for (const route of routes) {
            if (route.path === path) {
              return route;
            }
            if (route.children) {
              const found = findRoute(route.children, path);
              if (found) return found;
            }
          }
          return null;
        };

        const matchedRoute = findRoute(routes, path);
        return {
          path,
          name: matchedRoute ? matchedRoute.meta.title || "" : "",
          redirect: matchedRoute ? matchedRoute.redirect : "",
        };
      });
    },

    beforeEnter(el) {
      gsap.set(el, {
        opacity: 0,
      });
    },
    enter(el) {
      gsap.to(el, {
        opacity: 1,
        duration: 1,
        delay: el.dataset.index * 0.2 ?? 0,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-main {
  background-color: #f9f9f9;

  .nav-box {
    margin: 18px auto 0;
    width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .nav-item {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .nav-icon {
        margin: 0 5px;
        font-size: 12px;
      }

      .nav-name {
        font-weight: 400;
        font-size: 14px;
        color: #434e54;

        &:hover {
          cursor: pointer;
          text-decoration: underline;
          color: #0067db;
        }
      }

      &:last-child {
        .nav-name {
          color: #dddddd;
        }
      }
    }
  }

  .app-main-container {
    overflow-x: hidden;
  }
}
</style>
